import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Sift from "@/components/sift/Sift";
import { sysDatasourceQuerySearchList, sysDatasourceQueryId as _sysDatasourceQueryId } from "@/api/management/search";
export default {
  name: "Search",
  data: function data() {
    return {
      current: 1,
      size: 10,
      total: 0,
      baseUrl: process.env.BASE_URL,
      siftData: [],
      searchParams: {},
      list: [],
      tableColumnList: [],
      loading: false
    };
  },
  components: {
    Sift: Sift
  },
  computed: {},
  filters: {},
  watch: {},
  created: function created() {
    this.sysDatasourceQueryId();
  },
  methods: {
    sysDatasourceQueryId: function sysDatasourceQueryId() {
      var _this = this;

      this.loading = true;

      _sysDatasourceQueryId(this.$route.query.id).then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          _this.searchParams = data.data;

          _this.siftDataHandler();

          _this.tableColumnHandler();

          _this.$nextTick(function () {
            _this.onSearch();
          });
        } else {
          _this.$message.error(data.msg || "请求出错");
        }
      }).finally(function () {
        _this.loading = false;
      });
    },
    siftDataHandler: function siftDataHandler() {
      var _this2 = this;

      var queryCondDefList = this.searchParams.queryCondDefList;
      queryCondDefList.forEach(function (item) {
        switch (item.type) {
          case "0":
            _this2.siftData.push({
              type: "text",
              key: item.queryField,
              label: item.showName
            });

            break;

          case "1":
            var selectData = [];
            var exchange = JSON.parse(item.exchange) || [];
            exchange.forEach(function (e) {
              selectData.push({
                value: e.value,
                label: e.name
              });
            });

            _this2.siftData.push({
              type: "select",
              key: item.queryField,
              label: item.showName,
              data: selectData
            });

            break;

          case "2":
            var selectsData = [];
            var exchange = JSON.parse(item.exchange) || [];
            exchange.forEach(function (e) {
              selectsData.push({
                value: e.value,
                label: e.name
              });
            });

            _this2.siftData.push({
              type: "selects",
              key: item.queryField,
              label: item.showName,
              data: selectsData
            });

            break;

          case "3":
            if (item.queryType === "1") {
              _this2.siftData.push({
                type: "bedate",
                key: item.queryField,
                label: item.showName,
                sysDatasourceQuery: true
              });
            } else {
              _this2.siftData.push({
                type: "date",
                key: item.queryField,
                label: item.showName,
                sysDatasourceQuery: true
              });
            }

            break;
        }
      });
    },
    tableColumnHandler: function tableColumnHandler() {
      var _this3 = this;

      var queryResultDefList = this.searchParams.queryResultDefList;
      queryResultDefList.forEach(function (item) {
        _this3.tableColumnList.push({
          fieldName: item.fieldName,
          showName: item.showName,
          fieldType: item.fieldType,
          exchange: item.exchange
        });
      });
    },
    translateValue: function translateValue(fieldName, exchange) {
      return fieldName;
    },
    changePage: function changePage(page) {
      this.current = page;
      this.getList();
    },
    changeSize: function changeSize(value) {
      this.size = value;
      this.onSearch();
    },
    onSearch: function onSearch() {
      this.current = 1;
      this.getList();
    },
    getList: function getList() {
      var _this4 = this;

      this.loading = true;
      var searchData = this.$refs.needSift.getValue();
      var queryCondDefList = this.searchParams.queryCondDefList;
      var bedateKeys = [];
      queryCondDefList.forEach(function (item, index) {
        if (item.type === "3" && item.queryType === "1") {
          bedateKeys.push(item.queryField);
        }
      });
      var queryParams = [];

      for (var item in searchData) {
        if (bedateKeys.includes(item)) {
          queryParams.push({
            key: item,
            value: "".concat(searchData[item][0], ",").concat(searchData[item][1])
          });
        } else {
          queryParams.push({
            key: item,
            value: searchData[item]
          });
        }
      }

      var obj = {
        current: this.current,
        size: this.size,
        queryId: this.searchParams.id,
        queryParams: queryParams
      };
      sysDatasourceQuerySearchList(obj).then(function (_ref2) {
        var data = _ref2.data;

        if (data.code == 0) {
          _this4.list = data.data.records;
          _this4.total = data.data.total;
        } else {
          _this4.$message.error(data.msg || "请求出错");
        }
      }).finally(function () {
        _this4.loading = false;
      });
    }
  }
};